<!-- EditUniverseButton.vue -->
<template>
  <div class="has-text-centered stk-color-text-normal">
    <Button v-if="variant === 'button'" v-on:click="modalOpen = true" shade="warning">
      Edit Universe
    </Button>
    <a v-else href="#_" v-on:click="modalOpen = true">
      <i class="fas fa-edit"></i>
    </a>
    <b-modal
      v-model="modalOpen"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <EditUniverseModal v-bind:parent="this" />
    </b-modal>
  </div>
</template>

<script>
import { Button } from '@stakeui';
import EditUniverseModal from './EditUniverseModal.vue';

export default {
  data() {
    return {
      modalOpen: false,
    };
  },
  props: {
    variant: {
      type: String,
      default: 'anchor',
    },
  },
  components: {
    EditUniverseModal,
    Button,
  },
};
</script>

<style lang="scss" scoped>
  .modal.is-active {
    .modal-card {
      background-color: #fff;
      align-self: center;
      text-transform: none;
      text-align: left;

      .b-table {
        max-height: 50vh;
        overflow: scroll;
      }
    }
  }
</style>
